import React from 'react';
import {Box, styled} from '@mui/material';
import {Body, designSystemToken} from '@lightricks/react-design-system';

type MetricCardVariant = 'default' | 'small';

interface MetricCardProps {
  title: string;
  value: string;
  variant?: MetricCardVariant;
}

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
  padding-top: 4px;
`;

const ValueText = styled(Box)<{variant: MetricCardVariant}>`
  color: ${designSystemToken('semantic.fg.primary')};
  font-family: 'Brown LL';

  ${({variant}) =>
    variant === 'small'
      ? `
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
        word-wrap: break-word;
      `
      : `
        font-size: 20px;
        font-weight: 700;
        line-height: 24px;
      `}
`;

function MetricCard(props: MetricCardProps) {
  const {title, value, variant = 'default'} = props;

  return (
    <Container>
      <Body size="md" color={designSystemToken('semantic.fg.neutral')}>
        {title}
      </Body>
      <ValueText variant={variant}>{value}</ValueText>
    </Container>
  );
}

export default MetricCard;
